import { Injectable, signal } from "@angular/core";
import { LoadingController } from "@ionic/angular";

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  isLoading = false;
  isLodingSignal = signal<boolean>(false);
  hasRenderedSignal = signal<boolean>(false);
  private requestId = 0;
  private overlay?: HTMLIonLoadingElement;
  constructor(public loadingController: LoadingController) { }

  async present(time?: number) {
    if (this.isLoading) return;
    this.isLoading = true;
    const requestId = ++this.requestId;
    let overlay: HTMLIonLoadingElement | undefined;
    try {
      overlay = await this.loadingController.create({
        message: "",
        mode: "ios",
        spinner: null,
        duration: time ? time : 20000,
        cssClass: "custom-loading",
      });
      // A cancelled create must never borrow a newer request's loading state.
      if (requestId !== this.requestId) {
        overlay.remove();
        return;
      }
      this.overlay = overlay;
      void overlay.onDidDismiss().then(() => {
        if (requestId === this.requestId) {
          this.overlay = undefined;
          this.isLoading = false;
        }
      });
      await overlay.present();
      if (requestId !== this.requestId) await this.dismissOverlay(overlay);
    } catch (err) {
      if (requestId === this.requestId) {
        this.overlay = undefined;
        this.isLoading = false;
      }
      if (overlay) await this.dismissOverlay(overlay);
      return err;
    }
  }

  async dismiss() {
    if (this.isLoading || this.isLodingSignal() ) {
      this.isLoading = false;
      this.hasRenderedSignal.set(true);
      ++this.requestId;
      const overlay = this.overlay;
      this.overlay = undefined;
      if (overlay) return this.dismissOverlay(overlay);
    }
  }

  private async dismissOverlay(overlay: HTMLIonLoadingElement) {
      try {
        const dismissed = await overlay.dismiss();
        if (!dismissed) overlay.remove();
        return dismissed;
      } catch (err) {
        // Catch NotFoundError and other DOM manipulation errors
        // These can occur when third-party browser features (like MIUI translation)
        // remove or modify loading elements during async operations
        if (err && (err.name === 'NotFoundError' || 
                    err.message?.includes('removeChild') ||
                    err.message?.includes('not a child'))) {
          // Silently suppress DOM manipulation errors from browser translation engines
          return;
        }
        // Re-throw unexpected errors for proper debugging
        console.warn('[LoadingService] Unexpected error during dismiss:', err);
        return;
      }
  }
}
